<template>
  <section class="match-game">
    <div class="match-game__container">
            <div class="match-game__switch">
      <!--        <div class="desc desc&#45;&#45;lightgrey pb-1 pr-2" :class="{'current-mode': !simpleLike}">-->
      <!--          {{ trans.get('pages:match_game.questions') }}-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <label>-->
      <!--            <input-->
      <!--              id="switchMatchgame"-->
      <!--              v-model="simpleLike"-->
      <!--              type="checkbox"-->
      <!--              checked="checked"-->
      <!--              class="tgl tgl&#45;&#45;purple tgl-light tgl-light&#45;&#45;purple"-->
      <!--            >-->
      <!--            <label-->
      <!--              for="switchMatchgame"-->
      <!--              class="tgl-btn"-->
      <!--            >-->
      <!--            </label>-->
      <!--          </label>-->
      <!--        </div>-->
      <!--        <div class="desc desc&#45;&#45;lightgrey pb-1 pl-2" :class="{'current-mode': simpleLike}">-->
      <!--          {{ trans.get('pages:match_game.standard') }}-->
      <!--        </div>-->
            </div>
      <div class="match-game__wrapper" v-if="user">
        <div
          v-show="!simpleLike" class="card-behind card-behind--right"
          :class="{'swing-out-right-fwd': simpleLike, 'swing-in-right-fwd': !simpleLike }"
        ></div>
        <div
          v-show="!simpleLike" class="card-behind card-behind--left"
          :class="{'swing-out-left-fwd': simpleLike, 'swing-in-left-fwd': !simpleLike }"
        ></div>

        <div
          v-if="message && message.visible"
          class="match-game__card-on-top"
          :class="{'transition': isVisible}"
        >
          <NoUserMediaCard
            v-if="message.type === 'MEDIA'" v-model="message"
            :current="current" @next="load"
          ></NoUserMediaCard>
          <JokerCard
            v-if="message.type === 'JOKER'" v-model="message" :current="current"
            @next="nextAction" @skip="skipAction"
          ></JokerCard>
          <LoveCard
            v-if="message.type === 'LOVE'" v-model="message" :current="current"
            @next="nextAction" @skip="skipAction"
          ></LoveCard>
          <LikeCard
            v-if="message.type === 'LIKE'" v-model="message" :current="current"
            @next="nextAction" @skip="skipAction"
          ></LikeCard>
        </div>

        <div
          v-if="current && current.swipeable===true"
          class="match-game__card-primary"
          :class="{ 'transition': isVisible }"
        >

          <Vue2InteractDraggable
            v-if="isVisible"
            :enabled="!showDetails"
            :interact-out-of-sight-x-coordinate="500"
            :interact-max-rotation="15"
            :interact-x-threshold="100"
            :interact-y-threshold="200"
            :interact-event-bus-events="interactEventBus"
            :interact-block-drag-down="true"
            @draggedLeft="emitAndNext('SKIP')"
            @draggedUp="emitAndNext('JOKER')"
            @draggedRight="emitAndNext('LOVE')"
            :style="interactDraggableStyle"
          >
            <DraggableProfileCard
              :profile="current.profile"
              :showProfileDetails="!showDetails"
            ></DraggableProfileCard>
          </Vue2InteractDraggable>
          <div v-show="showDetails">
            <profile-details :profile="current.profile"></profile-details>
          </div>
        </div>

        <div
          v-if="current && current.swipeable===false"
          class="match-game__card-primary"
          :class="{'transition': isVisible}"
        >
          <ProfileCard
            v-if="current.type === 'USER'"
            :profile="current.profile"
          ></ProfileCard>
          <NoMoreCard v-if="current.type === 'NO_MORE'" :current="current"></NoMoreCard>
          <NoMoreMatchesCard
            v-if="current.type === 'NO_MORE_MATCHES'" :current="current"
            @errorReason="handleErrorReason"
            @load="load"
          ></NoMoreMatchesCard>
          <NoMoreCoinsCard
            v-if="current.type === 'NOT_ENOUGH_COINS'"
            :current="current"
          ></NoMoreCoinsCard>
          <DailyLimitReachedCard
            v-if="current.type === 'DAILY_LIMIT_REACHED'"
            :current="current"
          ></DailyLimitReachedCard>
        </div>

        <div v-if="next" class="match-game__card-below">
          <ProfileCard v-if="next.type === 'USER'" :profile="next.profile"></ProfileCard>
          <no-more-card v-if="next.type === 'NO_MORE'" :current="next"></no-more-card>
        </div>

        <div class="match-game__buttons" v-show="showButtons">
          <div
            v-show="showButtons"
            class="button button__match-game button__match-game--dislike"
            @click="skipBtn"
          >
            <i class="demo-icon icon-close"></i>
          </div>
          <div class="wobble-hor-bottom">
            <div
              v-show="showButtons" class="button button__superlike"
              @click="jokerBtn"
            >
              <i class="demo-icon icon-joker-fill-cap"></i>
              <div class="symbol-left">J</div>
              <div class="symbol-right">J</div>
            </div>
          </div>
          <div
            v-show="showButtons"
            class="button button__match-game button__match-game--like"
            @click="loveBtn"
          >
            <i class="demo-icon icon-heart-icon"></i>
          </div>
        </div>
        <div class="match-game__button" v-show="!showButtons && showDetails">
          <div
            class="button button__match-game button__match-game--like"
            @click="hideDetails"
          >
            <i class="fa fa-arrow-up"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="clearfix mt-5"></div>
  </section>
</template>
<script>

import MatchGameMixin from '../../../front/components/MatchGame/MatchGameMixin';

import {Vue2InteractDraggable} from '../../../packages/vue2-interact/src';

import JokerCard from './JokerCard';
import LoveCard from './LoveCard';
import NoMoreCard from './NoMoreCard';
import DraggableProfileCard from './DraggableProfileCard';
import ProfileCard from './ProfileCard';
import NoMoreMatchesCard from './NoMoreMatchesCard';
import ProfileDetails from './ProfileDetails';
import LikeCard from './LikeCard';
import NoMoreCoinsCard from './NoMoreCoinsCard';
import NoUserMediaCard from './NoUserMediaCard';
import DailyLimitReachedCard from './DailyLimitReachedCard';

export default {
  name: 'MatchGameComponent',
  mixins: [MatchGameMixin],
  components: {
    DailyLimitReachedCard,
    NoUserMediaCard,
    NoMoreCoinsCard,
    LikeCard,
    ProfileDetails,
    NoMoreMatchesCard,
    ProfileCard,
    DraggableProfileCard,
    NoMoreCard,
    LoveCard,
    JokerCard,
    Vue2InteractDraggable
  },
  methods: {
    setGameType() {
      // disable quiz match
      this.simpleLike = true;
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    },
  },
};
</script>
